import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';

const listeners = [];

export class ClickOutside extends React.Component {
  static propTypes = {
    Component: PropTypes.any.isRequired,
    onClickOutside: PropTypes.func,
  };

  componentDidMount() {
    listeners.push(this.listener);
  }
  componentWillUnmount() {
    listeners.splice(listeners.indexOf(this.listener), 1);
  }

  listener = (evt) => {
    const domNode = findDOMNode(this.component);
    if (domNode && domNode.contains) {
      if (domNode === evt.target || domNode.contains(evt.target)) {
        return;
      }

      (this.props.onClickOutside || this.component.onClickOutside)(evt);
    }
  };

  render() {
    const {Component, onClickOutside, ...props} = this.props;
    return <Component ref={(comp) => { this.component = comp; }} {...props} />;
  }
}

export default function clickOutsideDecorator(Component) {
  return props => <ClickOutside Component={Component} {...props} />;
}

function onClick(evt) {
  listeners.forEach(listener => listener(evt));
}
function onReady() {
  document.addEventListener('click', onClick, false);
}

function checkLoad() {
  if (document.readyState !== 'complete') {
    setTimeout(checkLoad, 11);
  } else {
    // Delay adding click handler until react is loaded so that event.stopPropagation would work
    setTimeout(onReady, 100);
  }
}
if (typeof window !== 'undefined') {
  checkLoad();
}



// WEBPACK FOOTER //
// ./spa/Components/OnClickOutside.jsx